export const SUCCESS_GET_AUDIT_TABLES = 'SUCCESS_GET_AUDIT_TABLES';
export const FAILED_GET_AUDIT_TABLES = 'FAILED_GET_AUDIT_TABLES';

export const SUCCESS_GET_AUDIT_LOGS = 'SUCCESS_GET_AUDIT_LOGS';
export const FAILED_GET_AUDIT_LOGS = 'FAILED_GET_AUDIT_LOGS';

export const CLEAR_AUDIT_LOGS = 'CLEAR_AUDIT_LOGS';

export const SET_AUDIT_FILTERS = 'SET_AUDIT_FILTERS';
export const CLEAR_AUDIT_FILTERS = 'CLEAR_AUDIT_FILTERS';

export const SET_AUDIT_LOADING = 'SET_AUDIT_LOADING';



// WEBPACK FOOTER //
// src/state/constants/auditLogConstants.js